import React from 'react';

import {
  CustomMetricCalculator,
  validateCustomMetric,
  validateMetrics,
} from '@gogame/components';
import { useMountedState } from '@gogame/hooks-ts';

import FormHierarchyField from './FormHierarchyField';

const FormCustomMetricCalculator = ({
  padding = '16px 8px',
  onlyPublicValid,
  renderOptionMetric,
  ...props
}) => {
  const [areaData, setAreaData] = useMountedState(null);
  const handleLoadData = React.useCallback(({ data }) => {
    setAreaData(data);
  });

  const validate = React.useCallback(
    (value) => {
      let error = null;
      error = validateCustomMetric(value);
      if (!error && areaData && onlyPublicValid) {
        error = validateMetrics(
          value,
          areaData?.metrics,
          areaData?.genericMetrics
        );
      }
      return error;
    },
    [areaData, onlyPublicValid]
  );

  return (
    <FormHierarchyField
      {...props}
      validate={validate}
      vertical={true}
      padding={padding}
      onDataLoad={handleLoadData}
    >
      {({ field, area, error, ...props }) => {
        const data = area.data || {};

        return (
          <CustomMetricCalculator
            {...field}
            metrics={data.metrics}
            cohortMetrics={data.genericMetrics}
            renderOptionMetric={renderOptionMetric}
            loading={area.loading}
            dataCy={field.name}
            error={error}
            {...props}
          />
        );
      }}
    </FormHierarchyField>
  );
};

export default FormCustomMetricCalculator;
